import {
    ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_REQUEST,
    ORDER_DELIVERY_SCHEDULE_BALANCE_CHALLAN_BASE_STOCK_REPORT_SUCCESS,
    ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_FAILURE,
    ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_FILTER_REPORT_REQUEST,
    ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_FILTER_REPORT_SUCCESS,
    ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_FILTER_REPORT_FAILURE,
    SET_OUTSTANDING_BY_ACCOUNTS_DELI_SCHEDULE
  } from "../types/order-delivery-schedule-balance-stock-report-types";

  const initialState = {
    orderDeliveryScheduleBalanceBillBaseStockFilterOptions: {},
    orderDeliveryScheduleBalanceChallanBaseStockReport: {},
    outstandingByAccounts: {},
    loading: false,
    error: null,
  };
  
  const orderBalanceStockReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null,
          orderDeliveryScheduleBalanceChallanBaseStockReport: {}
        };
      }
      case ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          orderDeliveryScheduleBalanceBillBaseStockFilterOptions: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case ORDER_DELIVERY_SCHEDULE_BALANCE_CHALLAN_BASE_STOCK_REPORT_SUCCESS: {
        return {
          ...state,
          orderDeliveryScheduleBalanceChallanBaseStockReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case SET_OUTSTANDING_BY_ACCOUNTS_DELI_SCHEDULE: {
        return {
          ...state,
          outstandingByAccounts: {...(action.payload || {})},
          loading: false,
          error: null
        }
      }
      case ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      case ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default orderBalanceStockReportReducer;
  